export default __webpack_public_path__ + "static/media/149.4426e826.png";